const Money = {
    methods:{
        formatMoney(number, locale = 'pt-BR') {
            if(typeof number !== 'undefined')
                return number.toLocaleString(locale, {maximumFractionDigits: 2, minimumFractionDigits: 2});
        },
    }
}

export default Money